export const DEAL_COMPANIES_FETCH_REQUESTED = 'DEAL_COMPANIES_FETCH_REQUESTED'
export const PROPOSAL_CREATE_REQUESTED = 'PROPOSAL_CREATE_REQUESTED'
